import {
    ApplicationSelect,
    ApplicationSelectOption,
} from "../../../shared/components/application-select";

type ToolsPanelFilterSelectProps = {
    id: string;
    value: string;
    options: ApplicationSelectOption[];
    width: number;
    isFilterApplied: boolean;
    fallbackLabel: string;
    onChange: (value: string) => void;
};

export function ToolsPanelFilterSelect({
    id,
    value,
    options,
    width,
    isFilterApplied,
    fallbackLabel,
    onChange,
}: ToolsPanelFilterSelectProps) {
    const selectSx = {
        backgroundColor: isFilterApplied ? '#FACC2D' : 'transparent',
        '&:hover': {
            backgroundColor: isFilterApplied ? '#f4bf00' : 'transparent',
        },
        '& .MuiSvgIcon-root': {
            color: '#36454B',
            fontSize: '24px',
        },
    };

    return (
        <ApplicationSelect
            id={id}
            value={value}
            options={options}
            width={width}
            menuWidth={width}
            displayEmpty
            fallbackLabel={fallbackLabel}
            sx={selectSx}
            onChange={onChange}
        />
    );
}
